/* 相关车系 */
import React from 'react'
import Link from 'next/link'

import getLinkHref from 'lib/get-link-href'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { getZT } from 'lib/zt-util'

import Image from 'Components/image'
import Button from 'Components/button'

export interface ICarSystem {
  price: string
  series_name: string
  displacement: string
  car_models_count: number
  head_cover_url: string
  cover: string
  series_id: number
  car_models_list:
    | {
        car_id: number
      }[]
    | string
}

interface IProps {
  cars: ICarSystem[]
  gid: string
}

export default function CarSystem({ gid, cars }: IProps) {
  const { length } = cars

  /* 渲染一个车的时候车价格名字 */
  function renderCarInfio(data: ICarSystem) {
    return (
      <React.Fragment>
        <Link
          href={`/auto/series?seriesId=${data.series_id}`}
          as={`/auto/series/${data.series_id}`}
        >
          <a
            target="_blank"
            className="cover"
            onClick={() => {
              sendTeaCommEvent('click_related_series', {
                car_series_name: data.series_name,
                car_series_id: data.series_id,
                rank: 0,
                group_id: gid,
              })
            }}
          >
            <Image src={cars[0].cover || cars[0].head_cover_url} />
          </a>
        </Link>
        <section className="clearfix">
          {data.price !== '暂无报价' && (
            <Link
              href={`/dealer?seriesId=${data.series_id}&zt=${getZT(
                'pc_article_related_series'
              )}`}
              as={`/dealer/${data.series_id}?zt=${getZT(
                'pc_article_related_series'
              )}`}
            >
              <Button
                onClick={() => {
                  sendTeaCommEvent('click_related_series_button', {
                    car_series_name: data.series_name,
                    car_series_id: data.series_id,
                    rank: 0,
                    group_id: gid,
                    button_text: '询底价',
                  })
                }}
                type="primary"
                className="button"
              >
                询底价
              </Button>
            </Link>
          )}
          <Link
            href={`/auto/series?seriesId=${data.series_id}`}
            as={`/auto/series/${data.series_id}`}
          >
            <p className="name">{data.series_name}</p>
          </Link>
          <Link
            href={`/auto/series?seriesId=${data.series_id}`}
            as={`/auto/series/${data.series_id}`}
          >
            <p className="price">{data.price}</p>
          </Link>
        </section>
        <style jsx>
          {`
            section {
              padding: 0 24px;
            }
            section :global(.button) {
              float: right;
              min-width: 120px;
              margin-top: 11px;
              text-align: center;
            }
            .cover {
              display: block;
              width: 240px;
              height: 160px;
              margin: 8px auto 16px;
              cursor: pointer;
            }
            .name {
              max-width: calc(100% - 130px);
              line-height: 25px;
              font-size: 18px;
              font-weight: 500;
            }
            .price {
              margin-top: 4px;
              margin-bottom: 20px;
              color: #ff9100;
            }
          `}
        </style>
      </React.Fragment>
    )
  }

  /* 渲染汽车参数信息 */
  function renderParams(data: ICarSystem) {
    const carIds =
      typeof data.car_models_list === 'string'
        ? data.car_models_list
        : data.car_models_list.map(item => item.car_id).join(',')

    return (
      <section>
        <Link
          href={`/auto/images/list?seriesId=${data.series_id}`}
          as={getLinkHref(`/auto/series/${data.series_id}/images`)}
        >
          <div>
            <p className="label">实拍图片</p>
            <p className="text">查看更多</p>
          </div>
        </Link>
        <Link
          href={`/auto/params?carIds=${carIds}`}
          as={`/auto/params?carIds=${carIds}`}
        >
          <div>
            <p className="label">参数配置</p>
            <p className="text">排量{data.displacement}</p>
          </div>
        </Link>
        <Link
          href={`/auto/series?seriesId=${data.series_id}`}
          as={`/auto/series/${data.series_id}`}
        >
          <div>
            <p className="label">车型列表</p>
            <p className="text">{data.car_models_count}款在售车型</p>
          </div>
        </Link>
        <style jsx>
          {`
            div {
              display: inline-block;
              width: 33.3%;
              border-right: 1px solid #e6e6e6;
              text-align: center;
              cursor: pointer;
            }
            div:last-child {
              border-right: 0;
            }
            .label {
              line-height: 22px;
              font-size: 16px;
              font-weight: 500;
            }
            .text {
              line-height: 17px;
              margin-top: 5px;
              font-size: 12px;
              color: #999;
            }
          `}
        </style>
      </section>
    )
  }

  /* 多个车时候的车的信息 */
  function renderMoreInfo(data: ICarSystem, index: number) {
    return (
      <section className="clearfix">
        <Link
          href={`/auto/series?seriesId=${data.series_id}`}
          as={getLinkHref(`/auto/series/${data.series_id}`)}
        >
          <a
            onClick={() => {
              sendTeaCommEvent('click_related_series', {
                car_series_name: data.series_name,
                car_series_id: data.series_id,
                rank: index,
                group_id: gid,
              })
            }}
          >
            <div className="cover fl">
              <Image src={data.head_cover_url || data.cover} />
            </div>
            <div className="info fl">
              <p className="name">{data.series_name}</p>
              <p className="price">{data.price}</p>
            </div>
          </a>
        </Link>
        <Link
          href={`/dealer?seriesId=${data.series_id}`}
          as={`/dealer/${data.series_id}`}
        >
          <a>
            <Button
              onClick={() => {
                sendTeaCommEvent('click_related_series_button', {
                  car_series_name: data.series_name,
                  car_series_id: data.series_id,
                  rank: 0,
                  group_id: gid,
                  button_text: '询底价',
                })
              }}
              className="button"
            >
              询底价
            </Button>
          </a>
        </Link>
        <style jsx>
          {`
            section {
              padding: 16px 24px 20px 16px;
            }
            .cover {
              width: 90px;
              height: 60px;
            }
            .info {
              margin-left: 12px;
              font-weight: 500;
            }
            .name {
              line-height: 25px;
              margin-top: 6px;
              font-size: 18px;
            }
            .price {
              margin-top: 4px;
              color: #ff9100;
            }
            section :global(.button) {
              float: right;
              min-width: 80px;
              margin-top: 16px;
              text-align: center;
            }
            .button:hover {
              background-color: #ffe733;
            }
            .button:active {
              background-color: #ccb400;
            }
          `}
        </style>
      </section>
    )
  }

  return (
    <div className="whole">
      <h2>相关车系</h2>
      {length > 1 ? (
        cars.map((car: ICarSystem, index) => (
          <div key={car.series_name}>
            {renderMoreInfo(car, index)}
            {renderParams(car)}
          </div>
        ))
      ) : (
        <div>
          {renderCarInfio(cars[0])}
          {renderParams(cars[0])}
        </div>
      )}
      <style jsx>
        {`
          .whole {
            margin-bottom: 10px;
            padding-bottom: 20px;
            border: solid 1px #e6e6e6;
          }
          h2 {
            position: relative;
            width: 390px;
            line-height: 60px;
            padding-left: 26px;
            font-size: 18px;
            font-weight: 500;
            border-bottom: solid 1px #e6e6e6;
          }
          h2::before {
            content: '';
            position: absolute;
            top: 21px;
            left: 16px;
            width: 6px;
            height: 18px;
            background: #ffe100;
          }
        `}
      </style>
    </div>
  )
}
